import { render, staticRenderFns } from "./public_create.vue?vue&type=template&id=f9f18ee2&scoped=true"
import script from "./public_create.vue?vue&type=script&lang=js"
export * from "./public_create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f18ee2",
  null
  
)

export default component.exports